<template>
  <section class="hero p-2" style="background-color: #f4f4f6">
    <div class="container">
      <div class="block pt-6">
        <div v-if="hasTitle" class="colums is-mobile">
          <div class="column is-10 is-offset-1">
            <h1
              class="has-text-centered has-text-primary"
              :class="width < 768 ? 'is-size-3' : 'is-size-1'"
              style="font-family: Calibri; font-weight: bold"
            >
              REPRESENTAMOS MARCAS SEGURAS, EFICIENTES Y DURABLES
            </h1>
          </div>
        </div>
        <div v-if="hasTitle" class="colums is-mobile">
          <div class="column is-8 is-offset-2">
            <p
              class="has-text-centered has-text-primary"
              style="font-family: Calibri"
            >
              Nos hemos aliado estratégicamente con marcas destacadas en sus
              respectivas especialidades, con el objetivo de mejorar la
              eficiencia en la producción, reducir los costos operativos y
              elevar la calidad de los productos para beneficio de nuestros
              clientes.
              <router-link to="/equipo" class="has-text-yellow"
                >Conoce toda la gama de nuestros equipos.</router-link
              >
            </p>
          </div>
        </div>
        <div
          class="columns is-variable pt-6"
          :class="width < 768 ? '' : 'is-7'"
        >
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/CVC_logo.png"
                    alt="CVC_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/Innovatech_logo.png"
                    alt="Innovatech_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/Serpa_logo.png"
                    alt="Serpa_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-variable" :class="width < 768 ? '' : 'is-7'">
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/Correct_Pack_logo.png"
                    alt="Correct_Pack_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/Riqtech_logo.png"
                    alt="Riqtech_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/Mekitec_logo.png"
                    alt="Mekitec_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="columns is-variable pb-6"
          :class="width < 768 ? '' : 'is-7'"
        >
          <div class="column">
            <div class="card representadas">
              <div class="card-image p-4">
                <figure class="image">
                  <img
                    class="has-ratio"
                    src="../assets/Fumex_logo.png"
                    alt="Fumex_logo.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <p
                  class="pl-6 pr-6 pb-5 has-text-blue"
                  style="font-family: Calibri"
                >
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh
                </p>
                <p
                  class="is-bold pl-6 pr-6 pb-4"
                  style="font-family: Calibri; font-weight: 600"
                >
                  <router-link
                    to="/equipo"
                    class="is-transparent has-text-yellow"
                  >
                    Ver equipos
                  </router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="column"></div>
          <div class="column"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { useWindowSize } from "vue-window-size";

const props = withDefaults(
  defineProps<{
    hasTitle: boolean;
  }>(),
  { hasTitle: false }
);

const { width } = useWindowSize();
</script>
